<template>
	<v-card flat max-width="950px" class="mx-auto transparent">
        <HeadRoot 
            title="Interesting stuff"
            :length="0"
            btn_txt=""
            btn_to="" />

        <v-radio-group class="ml-5 mt-6" v-model="radios" row>
            <v-radio label="Articles" value="page"></v-radio>
            <v-radio label="Videos" value="video"></v-radio>
            <v-radio label="Documents" value="file"></v-radio>
            <v-radio label="All" value="all"></v-radio>
        </v-radio-group>

        <v-card outlined class="pb-6" v-if="loaded">
            <v-card-text class="pa-6">
                <div class="mt-3" v-for="(item, index) in items" :key="item.id">
                    <div class="d-flex align-start" v-if="radios==item.type || radios=='all'">
                        <div class="mr-4">
                            <v-icon size="18px" class="primary--text" v-if="item.type=='page'">fa-file fa-fw</v-icon>
                            <v-icon size="18px" class="primary--text" v-if="item.type=='video'">fa-video fa-fw</v-icon>
                            <v-icon size="18px" class="primary--text" v-if="item.type=='file'">fa-file-download fa-fw</v-icon>
                        </div>
                        <div>
                            <div class="black--text">
                                {{item.title}}
                            </div>
                            <div class="d-flex align-center ml-1">
                                <v-icon size="12px" color="bArticles" class="mr-2" v-if="item.sourceIcon=='person'">fa-user fa-fw</v-icon>
                                <v-icon size="12px" color="bArticles" class="mr-2" v-if="item.sourceIcon=='media'">fa-book-open fa-fw</v-icon>
                                <div class="body-2 grey--text text--darken-3">
                                    {{item.author}}
                                </div>
                            </div>
                            <v-btn depressed small class="accent mt-2" target="_blank" :href="item.url" v-if="item.type!='file'">
                                <v-icon size="12px" left>fa-link</v-icon>
                                <span style="font-size:11px" v-if="item.type=='page'">Go to article</span>
                                <span style="font-size:11px" v-if="item.type=='video'">Go to video</span>
                            </v-btn>
                            <v-btn depressed small class="accent mt-2" target="_blank" :href="item.file.url" v-if="item.type=='file'">
                                <v-icon size="12px" left>fa-file-download</v-icon>
                                <span style="font-size:11px">Download</span>
                            </v-btn>
                        </div>
                    </div>

                    <div class="pl-10 mt-6 mb-5" v-if="index<items.length-1 && (radios==item.type || radios=='all')">
                        <v-divider></v-divider>
                    </div>
                </div>
            </v-card-text>
        </v-card>

        <SendingLoader v-if="!loaded" />

	</v-card>
</template>

<script>
import Articles from '@/firebase/articles'
import Helpers from '@/services/helpers'

export default {
    data: () => ({
        loaded: false,
        items: [],
        radios: 'all'
    }),
    mounted() {
        this.init();
    },
    methods: {
        init() {
            Articles.getAll()
                    .then(response => {
                        if (response.status === true) {
                            this.items = Helpers.formatItems(response.query);
                            this.loaded = true;
                        } else {
                            this.$store.dispatch('setSnack', {kind:'error', text:'An error ocurred. Please try later.'});
                        }
                    });
        }
    }
}
</script>

<style scoped>
    a {
        color: white !important;
    }
</style>
